var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var node = require('./node');

var browser = require('./browser');

var _require = require('p-queue'),
    Queue = _require.default;

var _require2 = require('promise-timeout'),
    timeout = _require2.timeout;

var observe = require('observable-webworkers');

var mutexes = {};
var implementation;

function createReleaseable(queue, options) {
  var res;
  var p = new Promise(function (resolve) {
    res = resolve;
  });
  queue.add(function () {
    return timeout(function () {
      return new Promise(function (resolve) {
        res(function () {
          resolve();
        });
      });
    }(), options.timeout);
  });
  return p;
}

var createMutex = function createMutex(name, options) {
  if (implementation.isWorker) {
    return {
      readLock: implementation.readLock(name, options),
      writeLock: implementation.writeLock(name, options)
    };
  }

  var masterQueue = new Queue({
    concurrency: 1
  });
  var readQueue = null;
  return {
    readLock: function readLock() {
      // If there's already a read queue, just add the task to it
      if (readQueue) {
        return createReleaseable(readQueue, options);
      } // Create a new read queue


      readQueue = new Queue({
        concurrency: options.concurrency,
        autoStart: false
      });
      var localReadQueue = readQueue; // Add the task to the read queue

      var readPromise = createReleaseable(readQueue, options);
      masterQueue.add(function () {
        // Start the task only once the master queue has completed processing
        // any previous tasks
        localReadQueue.start(); // Once all the tasks in the read queue have completed, remove it so
        // that the next read lock will occur after any write locks that were
        // started in the interim

        return localReadQueue.onIdle().then(function () {
          if (readQueue === localReadQueue) {
            readQueue = null;
          }
        });
      });
      return readPromise;
    },
    writeLock: function writeLock() {
      // Remove the read queue reference, so that any later read locks will be
      // added to a new queue that starts after this write lock has been
      // released
      readQueue = null;
      return createReleaseable(masterQueue, options);
    }
  };
};

var defaultOptions = {
  concurrency: Infinity,
  timeout: 84600000,
  global: global,
  singleProcess: false
};

module.exports = function (name, options) {
  if (!options) {
    options = {};
  }

  if (typeof name === 'object') {
    options = name;
    name = 'lock';
  }

  if (!name) {
    name = 'lock';
  }

  options = Object.assign({}, defaultOptions, options);

  if (!implementation) {
    implementation = node(options) || browser(options);

    if (!implementation.isWorker) {
      // we are master, set up worker requests
      implementation.on('requestReadLock', function (name, fn) {
        if (!mutexes[name]) {
          return;
        }

        mutexes[name].readLock().then(function (release) {
          return fn().finally(function () {
            return release();
          });
        });
      });
      implementation.on('requestWriteLock', /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, fn) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (mutexes[name]) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  mutexes[name].writeLock().then(function (release) {
                    return fn().finally(function () {
                      return release();
                    });
                  });

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }

  if (!mutexes[name]) {
    mutexes[name] = createMutex(name, options);
  }

  return mutexes[name];
};

module.exports.Worker = function (script, Impl) {
  Impl = Impl || global.Worker;
  var worker;

  try {
    worker = new Impl(script);
  } catch (error) {
    if (error.message.includes('not a constructor')) {
      worker = Impl(script);
    }
  }

  if (!worker) {
    throw new Error('Could not create Worker from', Impl);
  }

  observe(worker);
  return worker;
};